<template>
  <div class="setting-view">
    <div class="setting-header">
      <div class="color-container">
        <div style="font-size: 14px;">主题颜色</div>
        <div class="color-item" @click="setThemeColor(defaultColor[0])" :style="{ background: defaultColor[0] }">
          <i v-show="color == defaultColor[0]" class="el-icon-check" style="color: #fff;"></i>
        </div>
        <div class="color-item" @click="setThemeColor(defaultColor[1])" :style="{ background: defaultColor[1] }">
          <i v-show="color == defaultColor[1]" class="el-icon-check" style="color: #fff;"></i>
        </div>
        <div class="color-item" @click="setThemeColor(defaultColor[2])" :style="{ background: defaultColor[2] }">
          <i v-show="color == defaultColor[2]" class="el-icon-check" style="color: #fff;"></i>
        </div>
        <div class="color-item" @click="setThemeColor(defaultColor[3])" :style="{ background: defaultColor[3] }">
          <i v-show="color == defaultColor[3]" class="el-icon-check" style="color: #fff;"></i>
        </div>
        <el-color-picker title="自定义颜色" v-model="pickerColor" @change="changeThemeColor"></el-color-picker>
      </div>
       <div style="display: flex;align-items: center;">
        <div style="font-size: 14px;margin-right: 10px;">聊天提示音</div>
        <div><el-switch @change="soundChange" v-model="sound"></el-switch></div>
      </div>
    </div>
    
    <ul class="list">
      <div class="title" style="padding: 5px 16px;">模型设置</div>
      <!-- 标准件保存地址 -->
      <li class="item" v-if="!isGreatIM"><model-bzj-save :config="config" @configChange="configChange"></model-bzj-save></li>
      <!-- 外购件保存地址 -->
      <li class="item" v-if="!isGreatIM"><model-wgj-save :config="config" @configChange="configChange"></model-wgj-save></li>
      <!-- 我的常用零配件保存位置 -->
      <!-- <li class="item"><model-often-save :config="config" @configChange="configChange"></model-often-save></li> -->
       <!-- 模型附件属性 -->
        <li><model-custom-name></model-custom-name></li>
      <!-- 标准件命名规范 -->
      <li class="item" v-if="!isGreatIM"><model-name-role :config="config" @configChange="configChange"></model-name-role></li>
      <!-- 辅助设计 -->
      <li class="item" v-if="!isGreatIM"><model-setting></model-setting></li>
    </ul>

    <!-- <h2 class="title" id="modelSetting" style="margin-top: 16px;">显示设置</h2> -->
    <layout-setting :config="config" @configChange="configChange"  v-if="!isGreatIM"></layout-setting>
    <!-- 开机启动 -->
    <div class="item-crad mr-b">
      <div class="row">
        <div>
          <div class="title">开机自启</div>
          <div class="subtitle">系统启动时自动运行应用</div>
        </div>
        <div><el-switch @change="autoStartChange"  v-model="autoStart"></el-switch></div>
      </div>
    </div>
    <!-- 账号设置 -->
    <div class="item-crad">
      <div class="row">
        <div>
          <div class="title">账号设置</div>
          <div class="subtitle">
            <span>当前账号</span>
            <span style="margin-left: 12px;margin-right: 12px;color: #333;">{{ Auth.UserName }}</span>
            <el-tag type="success">已登录</el-tag>
          </div>
        </div>
        <div><div> <el-button type="danger" plain size="medium" @click="handleLogin">退出登录</el-button></div></div>
      </div>
    </div>
  </div>
</template>

<script>
import {AuthService} from '@/service'
import {WinForm} from '@/libs'

import IsShowPhone from './IsShowPhone.vue';
import ModelSetting from './model-setting.vue';
import ModelNameRole from './model-name-role.vue';
import ModelWgjSave from './model-wgj-save.vue';
import ModelBzjSave from './model-bzj-save.vue';
import ModelOftenSave from './model-often-save.vue';
import modelCustomName from './model-customName.vue';

import LayoutSetting from './layout-setting.vue';
import { convertRgbToHex, convertHexToRgb } from '@mdhnpm/rgb-hex-converter';
import {MessageBox} from "element-ui";

export default {
  components: { IsShowPhone, ModelSetting, ModelNameRole, ModelWgjSave, ModelBzjSave, ModelOftenSave, LayoutSetting,modelCustomName },
  data() {
    return {
      configKey: "",//保存在store中的key
      config: {
        activeNewTab: true,//立即激活页签
        remindToDocument: false,
        watchExtension: '',
        remindToDrawing: true,
        drawingShowRow: '',

        modelSaveType: 1,//模型下载保存是否每次询问
        modelSavePath: "",//模型下载保存位置
        modelWgjSaveType: 1,
        modelWgjSavePath: "",
        modelOftenSaveType: 1,
        modelOftenSavePath: "",

        modelNameRole: "标准[名称规格]",//命名规则
        imSavePath: '',//会话中的文件默认下载位置
        pdmDrawingMgr: false,//是否开启PDM图纸管理
        isImBeep: true,//是否开启会话提示音
        docSavePath: '',
        showAdvert: true,
        drawNameRole:"文件名",
        documentNameRole:"文件名",

        layoutCollectComp: 'card',
      },
      color: '',
      pickerColor: '',
      defaultColor: ['#2B98BF','#2A85CB','#124B92','#292F2D'],
      autoStart: false,
      sound: false,
      Auth: {},
      isGreatIM: false,
    }
  },
  mounted() {
    this.isGreatIM = md.getAppName() == 'GreatIM';
    this.Auth = AuthService.user();
    this.configKey = `sjb_config_${this.Auth.UserID}`;
    this.getConfig();
    this.getThemeConfig()
  },
  methods: {
    getThemeConfig() {
      const themeStr = md.getTheme ? md.getTheme() : '';
      if(themeStr) {
        const themeObj = JSON.parse(themeStr);
        if(themeObj.ThemeType === 'UserCustomTheme') {
          const arr = themeObj.Rgb1.split(',');
          const hex = convertRgbToHex(Number(arr[0]), Number(arr[1]), Number(arr[2]));
          const editHex = `#${hex.toLocaleUpperCase()}`;
          if(this.defaultColor.includes(editHex)) {
            this.color = editHex;
          }else {
            this.pickerColor = editHex;
          }
        }
      }
      
    },
    getConfig() {
      // AutoStart NotAutoStart
      this.autoStart = md.getAutoStart ? md.getAutoStart() == 'AutoStart' : false;
      // null 'false' true
      this.sound = md.getDisableSound ? md.getDisableSound() != 'false' : false;

      let config = WinForm.storge.get(this.configKey) || {};
      config && Object.assign(this.config, config || {});
    },
    configChange(key, value) {
      this.config[key] = value;
      this.saveConfig();
    },
    saveConfig() {
      this.inputNameRoleTimer && clearTimeout(this.inputNameRoleTimer);
      this.inputNameRoleTimer = setTimeout(() => {
        WinForm.storge.set(this.configKey, this.config);
      }, 500);
    },
    setThemeColor(color) {
      if(this.color == color) {
        this.color = '';
        this.pickerColor = '';
        this.handleColor('');
        return;
      }
      this.color = color;
      this.pickerColor = '';
      this.handleColor(color);
    },
    changeThemeColor(color) {
      this.color = '';
      this.pickerColor = color;
      this.handleColor(color);
    },
    handleColor(color) {
      if(!color) {
        md.setTheme(JSON.stringify({ThemeType:"ColorPerHour",Rgb1:"0,0,0",Rgb2:"0,0,0"}));
        return;
      }
      const arr = convertHexToRgb(color);
      const pcColor = arr.join(',');
      const obj = { ThemeType:'UserCustomTheme',Rgb1: pcColor,Rgb2: pcColor };       
      md.setTheme(JSON.stringify(obj));
    },
    soundChange(val) {
      md.setDisableSound(val);
    },
    autoStartChange(val) {
      md.setAutoStart(val);
    },
    handleLogin() {
      MessageBox.confirm('您确认要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=> {
        const UserID = this.Auth.UserID;
        const UserMdt = this.Auth.UserMdt;
        md.swichUsers(`${UserID}`, UserMdt);
      }).catch(()=> {})
    }
  },
}
</script>

<style lang="less" scoped>
.setting-view{
  // width: 800px;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  .setting-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    background: #fff;
    padding: 10px 16px;
    box-shadow: 0 0 4px 0 #f7f7f7;
    border-radius: 4px;
  }
  .color-container {
    display: flex;
    align-items: center;
    gap: 12px;

    .color-item {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 24px;
      height: 24px;
      border-radius: 14px;
      // background: #409EFF;
    }
  }
  /deep/ .el-color-picker {
    height: 24px;
  }  
  /deep/ .el-color-picker__trigger {
    height: 24px;
    width: 24px;
    border: none;
    padding: 0; 
    border-radius: 50%;
  }
  /deep/ .el-color-picker__color {
    border: 0;
  }
  /deep/ .el-color-el-color-picker__color-inner {
    border-radius: 50%;
  }
  /deep/ .el-color-picker__color-inner {
    border-radius: 50%;
    // border: 1px solid #409EFF;
  }
  /deep/ .el-icon-close:before {
    content: "\e6d9";
  }
  /deep/ .el-color-picker__empty {
    color: #409EFF;
    font-size: 24px;
  }
  /deep/ .el-icon-arrow-down:before {
    content: "\e6da";
  }
  .item{
    background-color: #ffffff;
  }

  .item:not(:last-of-type){
    border-bottom: 1px solid #f1f1f1;
  }

   /deep/ .list {
    list-style: none;
    box-shadow: 0 0 4px 0 #f7f7f7;
    margin-bottom: 16px;
    border-radius: 4px;
    overflow: hidden;
    /deep/ .content {
      background-color: #fff;
      padding: 10px 20px;
      &:first-of-type {
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
      }
      &:last-of-type {
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
      }
    }
    /deep/ .content-title {
      font-size: 14px;
      font-weight: 500;
      margin: 0;
    }
  }
  /deep/ .content{
    display: flex;
    align-items: center;
  }
  /deep/ .content-text {
    color: #000;
    flex: 1;
    display: flex;
    flex-flow: nowrap column;
  }

  .item-crad {
    list-style: none;
    box-shadow: 0 0 4px 0 #f7f7f7;
    background: #fff;
    padding: 5px 20px 10px 20px;
    border-radius: 4px;
    .row {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .mr-b {
     margin-bottom: 16px;
  }
}
.title {
  color: #333;
  font-size: 14px;
  margin: 0;
  line-height: 28px;
  background: #fff;
  font-weight: 600;
}
.subtitle {
  color: #888;
  font-size: 12px;
  // margin-top: 6px;
  line-height: 20px;
}

</style>
